import styled from "styled-components";
import {Button, Checkbox, Input} from "antd";

export const Container = styled.div`
  background: linear-gradient(137.5deg, #39A086 29.77%, #80DDC8 101.61%), #FFFFFF;
  height: 100%;
  padding-bottom: 20px;
  min-height: 100%;
  overflow-y: auto;
`
export const Logo = styled.div`
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: center;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
export const Images = styled.div`
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 20px;
  overflow: hidden;
  margin-bottom: 32px;
`;
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const Title = styled.div`
  font-weight: 500;
  font-size: 26px;
  line-height: 39px;
  text-align: center;
  color: #FFFFFF;
  padding: 0 14px;
  margin-bottom: 6px;
`;
export const Desc = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
  padding: 0 14px;

`;
export const Next = styled(Button)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  background: ${props => props.theme.main || "#1D896D"};
  border-radius: 50px;
  width: 238px;
  height: 48px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  color: #FFFFFF;
  margin-top: 20px;
  border: none;
`;

export const Modal = styled.div`
  background: rgba(27, 27, 27, 0.5);
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 16px 32px;
  background: #FFFFFF;
  backdrop-filter: blur(20px);
  border-radius: 16px;
  width: calc(100% - 32px);
  position: relative;
  max-height: calc(100% - 24px);
  margin-top: 12px;
`;
export const ModalContentHead = styled.div`
  padding-top: 32px;
  height: 80px;

  & svg {
    position: absolute;
    top: 16px;
    right: 16px;
  }
`;
export const ModalContentBody = styled.div`
  height: calc(100% - 120px);
  flex: none;

  & .content {
    max-height: 100%;
    overflow-y: auto;
  }
`;
export const ModalContentFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 16px;
  height: 50px;
`;
export const ModalContentHeadTitle = styled.div`
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  text-transform: capitalize;
  color: #1B1B1B;

`;
export const ModalContentHeadDesc = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #494949;
  margin-top: 0px;
`;

export const ModalContentFooterCheck = styled(Checkbox)`
  & span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    height: 20px;
    color: #494949;
  }

  & .ant-checkbox-wrapper {
    align-items: center;
    display: flex;
  }

  & .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border: 1.5px solid #BEBEBE;
    border-radius: 4px;
    overflow: hidden;
  }

  & .ant-checkbox-checked .ant-checkbox-inner {
    border-color: ${props => props.theme.main || "#1D896D"} !important;
    background: ${props => props.theme.main || "#1D896D"};
    border-radius: 4px;
  }
`;
export const ModalContentFooterSubmit = styled(Button)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 48px;
  background: ${props => props.theme.main || "#1D896D"} !important;
  border-radius: 50px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  color: #FFFFFF !important;
  border: none !important;
  width: 124px;

  &.ant-btn[disabled] {
    opacity: 0.7;
  }
`;

export const InputLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  color: #5D5D5D;
  margin-top: 16px;
  margin-bottom: 3px;
`
export const InputView = styled(Input)`
  padding: 13px 16px;
  height: 50px;
  background: #FFFFFF;
  border: 1px solid #BEBEBE;
  border-radius: 10px;
`


export const PageIcon = (props:any) => (
    <svg width="178" height="122" viewBox="0 0 178 122" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M163.264 105.371H12.7502C9.54522 105.371 6.9458 102.762 6.9458 99.5446V10.1604C6.9458 4.5486 11.4769 0 17.0672 0H158.947C164.537 0 169.068 4.5486 169.068 10.1604V99.5446C169.068 102.762 166.469 105.371 163.264 105.371Z"
            fill="#E9F2EC"/>
        <path
            d="M169.068 14.2514H6.9458V10.1604C6.9458 4.5486 11.4769 0 17.0672 0H158.947C164.537 0 169.068 4.5486 169.068 10.1604V14.2514Z"
            fill="#C1EAD4"/>
        <path
            d="M159.994 44.5896H158.866L158.555 44.8994V46.0319C158.555 46.3855 158.272 46.6698 157.919 46.6698C157.567 46.6698 157.286 46.3855 157.286 46.0319V44.8994L156.994 44.5896H155.854C155.502 44.5896 155.219 44.3054 155.219 43.9517C155.219 43.5981 155.502 43.3138 155.854 43.3138H156.994L157.286 43.0041V41.8762C157.286 41.5226 157.572 41.2383 157.919 41.2383C158.267 41.2383 158.555 41.5226 158.555 41.8762V43.0041L158.866 43.3138H159.994C160.342 43.3138 160.627 43.6004 160.627 43.9517C160.627 44.303 160.342 44.5896 159.994 44.5896Z"
            fill="#9ECAA8"/>
        <path
            d="M20.5945 119.351H19.4664L19.1555 119.661V120.794C19.1555 121.147 18.8723 121.432 18.5201 121.432C18.1678 121.432 17.8869 121.147 17.8869 120.794V119.661L17.5945 119.351H16.4548C16.1025 119.351 15.8193 119.067 15.8193 118.713C15.8193 118.36 16.1025 118.076 16.4548 118.076H17.5945L17.8869 117.766V116.638C17.8869 116.284 18.1724 116 18.5201 116C18.8677 116 19.1555 116.284 19.1555 116.638V117.766L19.4664 118.076H20.5945C20.9422 118.076 21.2277 118.362 21.2277 118.713C21.2277 119.065 20.9422 119.351 20.5945 119.351Z"
            fill="#9ECAA8"/>
        <path
            d="M61.1835 28.4502C61.1835 29.0257 60.7207 29.4903 60.1474 29.4903C59.5741 29.4903 59.1113 29.0257 59.1113 28.4502C59.1113 27.8747 59.5741 27.4102 60.1474 27.4102C60.7207 27.4102 61.1835 27.8747 61.1835 28.4502Z"
            fill="#9ECAA8"/>
        <path
            d="M62.0009 115.767C62.0009 116.342 61.5381 116.807 60.9648 116.807C60.3915 116.807 59.9287 116.342 59.9287 115.767C59.9287 115.191 60.3915 114.727 60.9648 114.727C61.5381 114.727 62.0009 115.191 62.0009 115.767Z"
            fill="#9ECAA8"/>
        <path
            d="M11.979 34.2852C12.3612 34.2852 12.6697 34.5995 12.6697 34.9809C12.6697 35.3622 12.3635 35.6696 11.979 35.6696H5.08784C4.70794 35.6696 4.39941 35.3645 4.39941 34.9809C4.39941 34.5972 4.70794 34.2852 5.08784 34.2852H11.979Z"
            fill="#9ECAA8"/>
        <path
            d="M2.1336 34.2852C2.5135 34.2852 2.82432 34.5995 2.82432 34.9809C2.82432 35.3622 2.5135 35.6696 2.1336 35.6696H0.869575C0.489677 35.6696 0.181152 35.3645 0.181152 34.9809C0.181152 34.5972 0.489677 34.2852 0.869575 34.2852H2.1336Z"
            fill="#9ECAA8"/>
        <path
            d="M166.024 75.3008C165.642 75.3008 165.333 75.6151 165.333 75.9965C165.333 76.3778 165.64 76.6852 166.024 76.6852H172.915C173.295 76.6852 173.604 76.3802 173.604 75.9965C173.604 75.6128 173.295 75.3008 172.915 75.3008H166.024Z"
            fill="#9ECAA8"/>
        <path
            d="M175.867 75.3008C175.487 75.3008 175.176 75.6151 175.176 75.9965C175.176 76.3778 175.487 76.6852 175.867 76.6852H177.131C177.511 76.6852 177.819 76.3802 177.819 75.9965C177.819 75.6128 177.511 75.3008 177.131 75.3008H175.867Z"
            fill="#9ECAA8"/>
        <path
            d="M112.781 27.6053C112.781 29.237 114.105 30.566 115.73 30.566C117.356 30.566 118.68 29.237 118.68 27.6053C118.68 25.9735 117.356 24.6445 115.73 24.6445C114.105 24.6445 112.781 25.9758 112.781 27.6053ZM113.976 27.6053C113.976 26.6345 114.763 25.8441 115.73 25.8441C116.697 25.8441 117.485 26.6345 117.485 27.6053C117.485 28.576 116.699 29.3665 115.73 29.3665C114.761 29.3665 113.976 28.5783 113.976 27.6053Z"
            fill="#9ECAA8"/>
        <path
            d="M80.957 88.7951C80.957 89.6271 80.6968 90.265 80.1742 90.7088C79.6515 91.1526 78.9078 91.3745 77.9431 91.3745H77.1488V94.3583H75.9009V86.3867H78.0997C79.0529 86.3867 79.7689 86.5901 80.2432 86.9969C80.7175 87.4037 80.957 88.0046 80.957 88.7974V88.7951ZM77.1488 90.2789H77.8119C78.452 90.2789 78.9216 90.1633 79.2233 89.9299C79.5226 89.6965 79.6722 89.3336 79.6722 88.839C79.6722 88.3814 79.5387 88.0393 79.2693 87.8151C79.0022 87.5886 78.5832 87.4776 78.0168 87.4776H77.1488V90.2812V90.2789Z"
            fill="#9ECAA8"/>
        <path
            d="M86.0731 94.3591L85.8267 93.5201H85.7853C85.5067 93.8876 85.2258 94.1372 84.9449 94.269C84.6617 94.403 84.3002 94.4677 83.8582 94.4677C83.2895 94.4677 82.8474 94.3083 82.5297 93.987C82.2119 93.668 82.0508 93.215 82.0508 92.6303C82.0508 92.0085 82.2718 91.5393 82.7139 91.225C83.1559 90.9084 83.8305 90.7373 84.7354 90.7073L85.7323 90.6749V90.3537C85.7323 89.9677 85.6472 89.6788 85.4745 89.4892C85.3018 89.2974 85.0347 89.2026 84.6732 89.2026C84.3762 89.2026 84.093 89.2489 83.8213 89.339C83.5496 89.4315 83.2895 89.5378 83.0385 89.6603L82.6425 88.745C82.9556 88.574 83.2987 88.4445 83.6717 88.3567C84.0447 88.2666 84.3946 88.2227 84.7262 88.2227C85.4607 88.2227 86.0155 88.3891 86.3885 88.7242C86.7638 89.0593 86.9503 89.584 86.9503 90.3005V94.3637H86.0731V94.3591ZM84.245 93.4878C84.6917 93.4878 85.0485 93.3583 85.3179 93.0971C85.5873 92.8383 85.7231 92.4731 85.7231 92.0039V91.4793L84.9818 91.5116C84.4038 91.5324 83.9825 91.6341 83.72 91.8144C83.4576 91.9947 83.3263 92.2697 83.3263 92.6395C83.3263 92.9076 83.4023 93.118 83.5566 93.2636C83.7085 93.4115 83.9388 93.4854 84.245 93.4854V93.4878Z"
            fill="#9ECAA8"/>
        <path
            d="M93.648 88.3283V89.0309L92.6603 89.2227C92.7524 89.3498 92.8261 89.507 92.8859 89.6919C92.9435 89.8768 92.9757 90.0733 92.9757 90.2813C92.9757 90.903 92.7708 91.3907 92.3587 91.749C91.9465 92.1049 91.3825 92.2829 90.6618 92.2829C90.4776 92.2829 90.3095 92.269 90.1599 92.239C89.8951 92.41 89.7639 92.6111 89.7639 92.8399C89.7639 92.9786 89.826 93.0803 89.9504 93.1496C90.0747 93.2189 90.3003 93.2536 90.6319 93.2536H91.6403C92.2758 93.2536 92.7616 93.3969 93.0908 93.6789C93.4224 93.9632 93.5859 94.3723 93.5859 94.9062C93.5859 95.5903 93.3165 96.1173 92.7754 96.4871C92.2366 96.8592 91.4561 97.0441 90.4362 97.0441C89.6487 97.0441 89.0478 96.8985 88.6334 96.6096C88.2189 96.3184 88.0117 95.9046 88.0117 95.3661C88.0117 94.994 88.1245 94.6843 88.3479 94.43C88.5712 94.1781 88.8843 94.0025 89.2896 93.9031C89.1261 93.8314 88.9902 93.7135 88.8843 93.5518C88.7784 93.39 88.7255 93.2212 88.7255 93.0433C88.7255 92.8168 88.7853 92.6272 88.9097 92.4701C89.0317 92.3152 89.2113 92.1604 89.453 92.0078C89.1537 91.8738 88.912 91.6542 88.7255 91.3514C88.539 91.0486 88.4469 90.6927 88.4469 90.2859C88.4469 89.6318 88.6426 89.1257 89.0386 88.7651C89.4346 88.4045 89.9964 88.2266 90.7286 88.2266C90.892 88.2266 91.0647 88.2381 91.2443 88.2612C91.4239 88.2843 91.5574 88.3098 91.6495 88.3352H93.6503L93.648 88.3283ZM89.11 95.2968C89.11 95.5741 89.2297 95.7845 89.4691 95.9347C89.7086 96.0826 90.0425 96.1589 90.4753 96.1589C91.143 96.1589 91.6403 96.0595 91.9673 95.8607C92.2942 95.662 92.4577 95.3939 92.4577 95.0633C92.4577 94.8022 92.3679 94.6149 92.1883 94.504C92.0087 94.3931 91.6749 94.3376 91.1867 94.3376H90.2566C89.9043 94.3376 89.6257 94.4231 89.4185 94.5965C89.2113 94.7698 89.1077 95.0032 89.1077 95.2968H89.11ZM89.6372 90.2813C89.6372 90.6603 89.7293 90.9516 89.9158 91.1526C90.1023 91.356 90.3694 91.4577 90.7171 91.4577C91.4285 91.4577 91.7831 91.0625 91.7831 90.2674C91.7831 89.8745 91.6933 89.5717 91.5183 89.3591C91.3433 89.1465 91.0762 89.0401 90.7171 89.0401C90.3579 89.0401 90.0931 89.1465 89.9089 89.3568C89.727 89.5671 89.6349 89.8745 89.6349 90.279L89.6372 90.2813Z"
            fill="#9ECAA8"/>
        <path
            d="M97.348 94.4701C96.45 94.4701 95.7478 94.195 95.2412 93.6495C94.7347 93.1041 94.4814 92.3506 94.4814 91.3891C94.4814 90.4276 94.7163 89.6302 95.186 89.0663C95.6557 88.5023 96.3003 88.2227 97.1223 88.2227C97.8844 88.2227 98.4876 88.463 98.9297 88.9461C99.3718 89.4291 99.5928 90.0948 99.5928 90.943V91.6341H95.7455C95.7616 92.2189 95.9136 92.6696 96.1991 92.9839C96.4846 93.2982 96.8875 93.4554 97.4055 93.4554C97.7463 93.4554 98.064 93.4207 98.3587 93.356C98.6534 93.289 98.9689 93.1757 99.3073 93.0209V94.0633C99.008 94.2112 98.7041 94.3175 98.3979 94.3799C98.0916 94.4423 97.7417 94.4747 97.348 94.4747V94.4701ZM97.1223 89.1911C96.7332 89.1911 96.4201 89.3205 96.1852 89.5771C95.9504 89.8336 95.8099 90.2104 95.7662 90.705H98.3863C98.3794 90.208 98.2643 89.829 98.0433 89.5724C97.8222 89.3159 97.5137 89.1888 97.1246 89.1888L97.1223 89.1911Z"
            fill="#9ECAA8"/>
        <path
            d="M109.06 94.3575H107.829V90.6479C107.829 90.1833 107.739 89.8366 107.559 89.6078C107.38 89.379 107.094 89.2635 106.705 89.2635C106.187 89.2635 105.807 89.4229 105.568 89.7442C105.328 90.0655 105.206 90.6017 105.206 91.3528V94.3575H103.979V88.3274H104.939L105.112 89.1178H105.174C105.349 88.8289 105.595 88.6094 105.915 88.4522C106.235 88.2973 106.59 88.2188 106.979 88.2188C108.365 88.2188 109.058 88.9537 109.058 90.426V94.3575H109.06Z"
            fill="#9ECAA8"/>
        <path
            d="M115.999 91.332C115.999 92.3167 115.758 93.0863 115.274 93.6387C114.791 94.1911 114.116 94.4685 113.253 94.4685C112.714 94.4685 112.237 94.3413 111.821 94.0848C111.406 93.8305 111.088 93.4654 110.865 92.9892C110.642 92.5131 110.531 91.9607 110.531 91.332C110.531 90.3544 110.771 89.5917 111.252 89.0416C111.731 88.4938 112.408 88.2188 113.283 88.2188C114.158 88.2188 114.779 88.4984 115.267 89.0601C115.755 89.6217 115.997 90.3798 115.997 91.3297L115.999 91.332ZM111.795 91.332C111.795 92.7257 112.288 93.4214 113.273 93.4214C114.259 93.4214 114.735 92.7257 114.735 91.332C114.735 89.9383 114.245 89.2658 113.262 89.2658C112.746 89.2658 112.373 89.4437 112.143 89.7997C111.91 90.1556 111.795 90.6664 111.795 91.332Z"
            fill="#9ECAA8"/>
        <path
            d="M119.667 93.429C119.967 93.429 120.266 93.3804 120.565 93.281V94.2448C120.429 94.3072 120.254 94.3581 120.04 94.3997C119.826 94.4413 119.605 94.4621 119.375 94.4621C118.212 94.4621 117.632 93.8219 117.632 92.5414V89.2918H116.842V88.7255L117.69 88.2563L118.106 86.9805H118.864V88.321H120.508V89.2918H118.864V92.5206C118.864 92.828 118.937 93.0568 119.085 93.2048C119.232 93.3504 119.428 93.4266 119.667 93.4266V93.429Z"
            fill="#9ECAA8"/>
        <path
            d="M127.611 89.2979H126.202V94.3573H124.97V89.2979H124.019V88.6993L124.97 88.3064V87.9135C124.97 87.2016 125.129 86.6723 125.449 86.3279C125.769 85.9858 126.259 85.8125 126.918 85.8125C127.348 85.8125 127.774 85.8865 128.191 86.0367L127.866 87.0074C127.565 86.9057 127.275 86.8549 127.001 86.8549C126.727 86.8549 126.519 86.945 126.393 87.1253C126.266 87.3056 126.202 87.5737 126.202 87.9343V88.3272H127.611V89.2979Z"
            fill="#9ECAA8"/>
        <path
            d="M133.82 91.332C133.82 92.3167 133.579 93.0863 133.095 93.6387C132.612 94.1911 131.937 94.4685 131.074 94.4685C130.535 94.4685 130.058 94.3413 129.641 94.0848C129.227 93.8305 128.909 93.4654 128.686 92.9892C128.463 92.5131 128.352 91.9607 128.352 91.332C128.352 90.3544 128.592 89.5917 129.073 89.0416C129.552 88.4938 130.229 88.2188 131.103 88.2188C131.978 88.2188 132.6 88.4984 133.088 89.0601C133.576 89.6217 133.818 90.3798 133.818 91.3297L133.82 91.332ZM129.616 91.332C129.616 92.7257 130.109 93.4214 131.094 93.4214C132.08 93.4214 132.556 92.7257 132.556 91.332C132.556 89.9383 132.066 89.2658 131.083 89.2658C130.567 89.2658 130.194 89.4437 129.964 89.7997C129.731 90.1556 129.616 90.6664 129.616 91.332Z"
            fill="#9ECAA8"/>
        <path
            d="M139.413 94.3583L139.24 93.5678H139.178C139.008 93.8475 138.764 94.067 138.451 94.2288C138.135 94.3883 137.776 94.4692 137.371 94.4692C136.671 94.4692 136.148 94.2866 135.805 93.9237C135.46 93.5609 135.287 93.0085 135.287 92.2712V88.3281H136.526V92.047C136.526 92.5092 136.616 92.8559 136.797 93.0871C136.979 93.3182 137.263 93.4337 137.649 93.4337C138.165 93.4337 138.543 93.272 138.784 92.9507C139.026 92.6294 139.148 92.0886 139.148 91.3328V88.3281H140.38V94.3583H139.415H139.413Z"
            fill="#9ECAA8"/>
        <path
            d="M147.315 94.3575H146.083V90.6479C146.083 90.1833 145.993 89.8366 145.814 89.6078C145.634 89.379 145.349 89.2635 144.959 89.2635C144.441 89.2635 144.062 89.4229 143.822 89.7442C143.583 90.0655 143.461 90.6017 143.461 91.3528V94.3575H142.233V88.3274H143.194L143.366 89.1178H143.428C143.603 88.8289 143.85 88.6094 144.17 88.4522C144.49 88.2973 144.844 88.2188 145.233 88.2188C146.619 88.2188 147.313 88.9537 147.313 90.426V94.3575H147.315Z"
            fill="#9ECAA8"/>
        <path
            d="M151.077 94.4683C150.356 94.4683 149.795 94.1956 149.392 93.6501C148.986 93.1047 148.786 92.3397 148.786 91.355C148.786 90.3704 148.991 89.5962 149.401 89.0461C149.808 88.496 150.375 88.2209 151.1 88.2209C151.825 88.2209 152.438 88.5122 152.834 89.0969H152.896C152.836 88.6647 152.806 88.3226 152.806 88.073V85.875H154.038V94.3597H153.078L152.864 93.5693H152.806C152.412 94.1702 151.837 94.4707 151.077 94.4707V94.4683ZM151.406 93.4329C151.911 93.4329 152.277 93.285 152.509 92.9891C152.739 92.6933 152.857 92.2125 152.864 91.5469V91.3666C152.864 90.6062 152.744 90.0677 152.509 89.7464C152.272 89.4274 151.901 89.2656 151.397 89.2656C150.967 89.2656 150.633 89.4482 150.4 89.8134C150.168 90.1786 150.05 90.6986 150.05 91.3758C150.05 92.0531 150.163 92.5546 150.389 92.9059C150.614 93.2572 150.955 93.4329 151.406 93.4329V93.4329Z"
            fill="#9ECAA8"/>
        <path
            d="M67.9273 66.148C60.5274 56.5747 62.2496 42.744 71.7678 35.3201C81.2952 27.8778 95.082 29.609 102.475 39.1892C109.884 48.7464 108.155 62.5725 98.6277 70.0102C89.1096 77.434 75.3227 75.7052 67.925 66.148H67.9273Z"
            fill="#D9E2DE"/>
        <path
            d="M73.2712 63.8015C72.7302 63.8015 72.1937 63.5589 71.8368 63.0966C66.1107 55.6889 67.4461 44.99 74.8092 39.2465C75.6013 38.6294 76.7387 38.7727 77.3534 39.5678C77.9681 40.3628 77.8254 41.5046 77.0334 42.1217C71.2474 46.6333 70.1998 55.0418 74.6987 60.8639C75.3135 61.659 75.1684 62.8008 74.3787 63.4179C74.0471 63.6767 73.6557 63.7992 73.2689 63.7992L73.2712 63.8015Z"
            fill="white"/>
        <path
            d="M81.2952 39.8229C80.4939 39.8229 79.7595 39.2844 79.543 38.4708C79.2852 37.5001 79.8608 36.5016 80.8278 36.2428C82.1701 35.8845 83.5584 35.6927 84.9537 35.6719C85.9414 35.6765 86.7795 36.4623 86.7933 37.4677C86.8071 38.4731 86.0059 39.3006 85.0044 39.3145C83.9061 39.3283 82.8148 39.4809 81.7603 39.7628C81.6037 39.8044 81.4471 39.8252 81.2929 39.8252L81.2952 39.8229Z"
            fill="white"/>
        <path
            d="M46.5931 78.3562C44.1802 78.3562 42.2232 76.3916 42.2232 73.9694V67.6318H25.3856C22.9704 67.6318 20.8015 66.2821 19.7263 64.1118C18.6764 61.9969 18.8744 59.5216 20.2328 57.6078L39.4303 28.2152C39.4833 28.1344 39.5409 28.0535 39.5984 27.9749C41.2377 25.7976 44.072 24.9147 46.653 25.7838C49.2317 26.6528 50.9654 29.0704 50.9654 31.8V58.8536H52.911C55.3239 58.8536 57.2809 60.8182 57.2809 63.2404C57.2809 65.6626 55.3239 67.6272 52.911 67.6272H50.9654V73.9648C50.9654 76.387 49.0084 78.3516 46.5954 78.3516L46.5931 78.3562ZM29.8661 58.8559H42.2209V39.9404L29.8661 58.8559Z"
            fill="#9ECAA8"/>
        <path
            d="M141.623 78.3562C139.21 78.3562 137.253 76.3916 137.253 73.9694V67.6318H120.415C118 67.6318 115.831 66.2821 114.756 64.1118C113.706 61.9969 113.904 59.5216 115.263 57.6078L134.46 28.2152C134.513 28.1344 134.571 28.0535 134.628 27.9749C136.268 25.7976 139.102 24.9147 141.683 25.7838C144.261 26.6528 145.995 29.0704 145.995 31.8V58.8536H147.941C150.354 58.8536 152.311 60.8182 152.311 63.2404C152.311 65.6626 150.354 67.6272 147.941 67.6272H145.995V73.9648C145.995 76.387 144.038 78.3516 141.625 78.3516L141.623 78.3562ZM124.896 58.8559H137.251V39.9404L124.896 58.8559Z"
            fill="#9ECAA8"/>
        <path
            d="M105.669 68.0318C114.137 56.8337 111.954 40.7864 100.797 32.274C89.6417 23.7662 73.6561 25.9596 65.1878 37.1693C57.3204 47.5816 58.6651 62.1496 67.8402 70.9718L54.5322 88.5745L59.1992 92.1246L72.5118 74.5496C83.4505 81.0536 97.7946 78.4303 105.669 68.0318ZM73.6146 68.2214C65.0358 61.6712 63.3528 49.3428 69.864 40.7402C76.3775 32.1191 88.6678 30.4296 97.242 36.9867C105.823 43.5207 107.502 55.8491 100.986 64.4632C94.4768 73.0658 82.1842 74.7577 73.6146 68.2214V68.2214Z"
            fill="#9ECAA8"/>
        <path
            d="M43.3009 118.079C41.3392 120.684 37.63 121.187 35.0306 119.211C32.4381 117.226 31.9362 113.516 33.8978 110.907L51.3363 87.8634C53.3072 85.2609 57.0049 84.7548 59.6066 86.7401C62.1968 88.7094 62.7056 92.4398 60.7348 95.033L43.3009 118.081V118.079Z"
            fill="#453E77"/>
        <path
            d="M16.2958 8.73247C17.1592 8.73247 17.8591 8.02984 17.8591 7.16311C17.8591 6.29638 17.1592 5.59375 16.2958 5.59375C15.4324 5.59375 14.7324 6.29638 14.7324 7.16311C14.7324 8.02984 15.4324 8.73247 16.2958 8.73247Z"
            fill="white"/>
        <path
            d="M21.5087 8.73247C22.3721 8.73247 23.072 8.02984 23.072 7.16311C23.072 6.29638 22.3721 5.59375 21.5087 5.59375C20.6452 5.59375 19.9453 6.29638 19.9453 7.16311C19.9453 8.02984 20.6452 8.73247 21.5087 8.73247Z"
            fill="white"/>
        <path
            d="M26.7235 8.73247C27.5869 8.73247 28.2868 8.02984 28.2868 7.16311C28.2868 6.29638 27.5869 5.59375 26.7235 5.59375C25.8601 5.59375 25.1602 6.29638 25.1602 7.16311C25.1602 8.02984 25.8601 8.73247 26.7235 8.73247Z"
            fill="white"/>
    </svg>
)